export default __webpack_public_path__ + "static/media/volume-low-icon.5599ca29.svg";